import React, { Component } from 'react';

class CharacterGroup extends Component {
  state = { shownChars: '' }

  get defaultView() {
    return this.props.invertRender ? 'kana' : 'romaji';
  }

  get altView() {
    return this.props.invertRender ? 'romaji' : 'kana';
  }

  changeShownChars(newString) {
    this.setState({ shownChars: newString })
  }

  getShowableCharacters(whichKana) {
    let strRomajiCharacters = '';
    let strKanaCharacters = '';
    Object.keys(this.props.characters).map(character => {
      strRomajiCharacters += this.props.characters[character][0] + ' · ';
      strKanaCharacters += character + ' · ';
    });
    strRomajiCharacters = strRomajiCharacters.slice(0, -2);
    strKanaCharacters = strKanaCharacters.slice(0, -2);

    if (whichKana === 'romaji') {
      return strRomajiCharacters;
    }
    else {
      return strKanaCharacters;
    }
  }

  componentDidMount() {
    this.changeShownChars(this.getShowableCharacters(this.defaultView));
  }

  render() {
    return (
      <div
      className={
        'choose-row'
          + (this.props.groupName.endsWith('_a') || this.props.groupName.endsWith('_s') ? ' alt-row' : '')
          + (['h_group16_a','k_group18_a','k_group29_a'].includes(this.props.groupName) ? ' divider-row' : '')
      }
      onClick={() => {
        this.props.handleToggleSelect(this.props.groupName);
        this.changeShownChars(this.getShowableCharacters(this.defaultView));
      }}
      onMouseDown = { () => this.changeShownChars(this.getShowableCharacters(this.altView)) }
      onMouseOut = { () => this.changeShownChars(this.getShowableCharacters(this.defaultView)) }
      onTouchStart = { () => this.changeShownChars(this.getShowableCharacters(this.altView)) }
      onTouchEnd = { () => this.changeShownChars(this.getShowableCharacters(this.defaultView)) }
    >
      <span className={this.props.selected ?
          'glyphicon glyphicon-small glyphicon-check' :
          'glyphicon glyphicon-small glyphicon-unchecked'}></span> {this.state.shownChars}
      </div>
    );
  }
}

export default CharacterGroup;
